import { Navigate, useLocation } from 'react-router-dom';
import { resolveHomePath, useAuth } from '@/shared/lib/auth';
import { isNpsSession } from '@/shared/lib/nps-session';

function isNpsPath(pathname: string): boolean {
  return pathname === '/nps' || pathname.startsWith('/nps/');
}

/**
 * Impede cruzamento entre zonas: sessão api-v2 (NPS) ↔ legacy-api (CRM).
 * Nunca redireciona para /login — só troca entre homes das zonas.
 */
export function AuthZoneGuard() {
  const { user, authSource, startPath, isLoading } = useAuth();
  const { pathname } = useLocation();

  if (isLoading || !user || !authSource) return null;

  const legacyHome = startPath ?? resolveHomePath(user, 'legacy');

  if (isNpsSession(authSource) && !isNpsPath(pathname)) {
    return <Navigate to="/nps" replace />;
  }

  if (authSource === 'legacy' && isNpsPath(pathname)) {
    return <Navigate to={legacyHome} replace />;
  }

  return null;
}
